const template = require('./list-menu-item.tpl').default;

module.exports = DomClass(template, function ListMenuItem() {
	this.onclick = function() {
		if (typeof(this.target) == 'function') this.target();
		on(this, 'select').fire(this);
	};
});
